import CTAButton from '../../ui/ctaButton';
import { openSimplePracticeContact } from '../../utils/simplePractice';
import { WidgetWrapper, HelperNote } from './styles';

/**
 * SimplePractice contact CTA.
 *
 * Opens the SimplePractice contact form in a new tab — the same pattern as every
 * other SP CTA on the site (consultation, client portal, per-practitioner booking).
 * Replaces the old in-page GHL contact form iframe; submissions go to SimplePractice.
 */
const SimplePracticeContactWidget = ({ label = 'Contact Our Team', note }) => (
  <WidgetWrapper>
    <CTAButton variant="contained" text={label} onClick={openSimplePracticeContact} />
    {note && <HelperNote>{note}</HelperNote>}
  </WidgetWrapper>
);

export default SimplePracticeContactWidget;
